export default __webpack_public_path__ + "static/nithish-karthik-7b21ce69acd404be5f476a05d09d6692.webp";